import { useVpsHostingSectionContent } from './useVpsHostingSectionContent';
import { parseVpsHostingHeroContent } from '../utils/vpsHostingContent';

export const useVpsHostingHeroContent = () =>
  useVpsHostingSectionContent(parseVpsHostingHeroContent);
